import { render } from "./BillRegister.vue?vue&type=template&id=f1698f6c&scoped=true"
import script from "./BillRegister.vue?vue&type=script&lang=js"
export * from "./BillRegister.vue?vue&type=script&lang=js"

import "./BillRegister.vue?vue&type=style&index=0&id=f1698f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1698f6c"]])

export default __exports__